import { API_KEY, API_URL } from '../../config';
import {
    parseStringOr,
    isObjectNotEmpty
} from './AppxUtils';


class ModelClass {
    constructor(name) {
        this.name = name;
        this.rec = {};
        this.uri = "";
        this.id = 0;
    }

    preload(data) {
        if (isObjectNotEmpty(data)) {
            for (let k in data) {
                this.rec[k] = data[k];
            }

            this.id = parseInt(data.id) || 0;
        }
    }

    getKey() {
        return `${this.name}.${this.id}`;
    }

    get(k) {
        return this.rec[k] || "";
    }

    getAll() {
        return this.rec || {};
    }

    set(k, v) {
        this.rec[k] = v;
    }

    setAll(v) {
        this.rec = v;
        return;
    }

    getUri() {
        return this.uri;
    }

    setUri(v) {
        this.uri = v;
    }
}

class ModelList {
    constructor(name){
        this.name = name;
        this.total = 0;
        this.list = [];
    }

    loadFromArr(tbl) {
        try {
            for (let i = 0; i < tbl.length; i++) {
                let row = tbl[i];
                let mdl = new ModelClass(this.name);
                mdl.preload(row);
                this.list.push(mdl);
            }
        }
        catch (err) {
            console.error("Model.Collection:" + err);
        }
    }

    setTotal(total) {
        this.total = total;
    }

    map(cb) {
        if (this.list.length === 0) {
            return;
        }

        return this.list.map(cb);
    }
}

const reqHeaders = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    //'Cache-Control': 'no-cache',
    'Cache-Control': 'no-store'
};

class AppxApi {
    constructor() {
        this.url = parseStringOr(API_URL, "");

        if (this.apiUrl === "") {
            throw new Error('Api Url is riquired!');
        }

        this.apikey = parseStringOr(API_KEY, "");

        if (this.apikey === "") {
            throw new Error('Api Key is riquired!');
        }
    }

    async getModelList(p) {
        //p should contain sessionToken,org,app,data{} objects
        let model = p.model;
        let col = new ModelList(model);
        let body = {...p};
        body.apikey = this.apikey;
        body.action = "list";

        try {
            let response = await fetch(`${this.url}/${model}/list`, {
                method: 'POST',
                crossDomain: true,
                headers: reqHeaders,
                body: JSON.stringify(body)
            });

            if (response == null) {
                throw new Error('Error: Response is null');
            }

            let json = await response.json();

            if (json == null) {
                throw new Error('Error: Json is null');
            }

            col.loadFromArr(json.list);
            col.setTotal(json.total);

            return col;
        }
        catch (error) {
            console.log(error);
            return col;
        }
    }

    async getModelData(p) {
        let model = p.model;
        let body = {...p};
        body.apikey = this.apikey;
        body.action = "get";
        let col = new ModelClass(model);
        let id = parseInt(p.id) || 0;

        if (id === 0) {
            return col;
        }

        try {
            let response = await fetch(`${this.url}/${model}/${id}`, {
                method: 'POST',
                crossDomain: true,
                headers: reqHeaders,
                body: JSON.stringify(body)
            });

            if (response == null) {
                throw new Error('Error: Response is null');
            }

            let json = await response.json();

            if (json == null) {
                throw new Error('Error: Json is null');
            }

            col.preload(json.data);

            return col;
        }
        catch (error) {
            console.log(error);
            return col;
        }
    }
    //note: p should contain a p.data object to be passed to the function in appxserver model
    async doModelAction(p) {
        let model = p.model;
        let action = p.action;
        let body = {...p};
        body.apikey = this.apikey;
        let col = new ModelClass(model);
        let url = this.url + "/" + model;
        let id = parseInt(p.id) || 0;

        if (id > 0) {
            url += '/' + id;
        }

        url += '/' + action;

        try {
            let response = await fetch(url, {
                method: 'POST',
                crossDomain: true,
                headers: reqHeaders,
                body: JSON.stringify(body)
            });

            let res = await response.json();

            if ( res == null ) {
                return col;
            }

            return res;
        }
        catch (error) {
            console.log(error);
            return col;
        }
    }

    async createModelData(p) {
        let model = p.model;
        let body = {...p};
        body.apikey = this.apikey;
        body.action = "set";
        let col = new ModelClass(model);

        try {
            let response = await fetch(`${this.url}/${model}/create`, {
                method: 'POST',
                crossDomain: true,
                headers: reqHeaders,
                body: JSON.stringify(body)
            });

            if (response == null) {
                throw new Error('Error: Response is null');
            }

            let json = await response.json();

            if (json == null) {
                throw new Error('Error: Json is null');
            }

            col.preload(json.data);

            return col;
        }
        catch (error) {
            console.log(error);
            return col;
        }
    }
}


export {
    AppxApi,
    ModelClass,
    ModelList
};
